import { isStandaloneMode } from '@constants/app-modes';
import {
  getItemFromCrossDomainStorage,
  setItemInCrossDomainStorage,
  removeItemFromCrossDomainStorage,
  getAllKeysFromCrossDomainStorage,
} from './crossDomainStorage';

export const getItemFromStorage = (
  key: string,
  defaultValue?: string | boolean | number
): string | boolean | number => {
  if (isStandaloneMode()) {
    return localStorage.getItem(key) || defaultValue;
  }

  return defaultValue;
};

export const setItemInStorage = async (
  key: string,
  value: string | boolean | number
): Promise<void> => {
  if (isStandaloneMode()) {
    localStorage.setItem(key, String(value));

    try {
      await setItemInCrossDomainStorage(key, value);
    } catch (e) {
      console.error('CrossDomainStorage::setItemInStorage', e);
    }
  }
};

export const removeItemFromStorage = async (key: string): Promise<void> => {
  try {
    if (isStandaloneMode()) {
      localStorage.removeItem(key);

      try {
        await removeItemFromCrossDomainStorage(key);
      } catch (e) {
        console.error('CrossDomainStorage::removeItemFromStorage', e);
      }
    }
  } catch (e) {
    console.error('LocalStorageHandler::removeItemFromStorage', e);
  }
};

/**
 * Synchronizes all values from global (cross-domain) storage to local storage.
 * Should be called on application startup.
 * @returns Promise that resolves when synchronization is complete
 */
export const syncGlobalToLocalStorage = async (): Promise<void> => {
  if (!isStandaloneMode()) {
    return;
  }

  try {
    const keys = await getAllKeysFromCrossDomainStorage();
    console.log(`Synchronizing ${keys.length} keys from global to local storage`);

    const syncPromises = keys.map(async (key) => {
      try {
        const value = await getItemFromCrossDomainStorage(key);
        if (value != null) {
          const localValue = localStorage.getItem(key);
          if (localValue !== String(value)) {
            console.log(`Syncing global -> local storage for key: ${key}`);
            localStorage.setItem(key, String(value));
          }
        }
      } catch (e) {
        console.error(`Error syncing key ${key} from global to local storage`, e);
      }
    });

    await Promise.all(syncPromises);
    console.log('Global to local storage synchronization complete');
  } catch (e) {
    console.error('Error during global to local storage synchronization', e);
  }
};
